<template lang="pug">
	.section-container
		invite-codes
		analytics
		ranking
		ticket

</template>

<script>
import InviteCodes from './InviteCodes.vue'
import Analytics from './Analytics.vue'
import Ranking from './Ranking.vue'
import Ticket from './Ticket.vue'

export default {
	components: {
		InviteCodes,
		Analytics,
		Ranking,
		Ticket
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.panel") + ' | ' + this.$t("title.home") })
	}
}
</script>
